/** Durations in ms */

export const DURATION__XXS = 5;
export const DURATION__XS = 75;
export const DURATION__S = 125;
export const DURATION__M = 225;
export const DURATION__L = 325;
export const DURATION__XL = 525;

export const DURATION__SMALL = DURATION__S;
export const DURATION__LARGE = DURATION__L;

const Durations = {
  xxs: 50,
  xs: 75,
  s: 125,
  m: 225,
  l: 325,
  xl: 525,
} as const;

export default Durations;
